
export default function Footer() {
  return (
    <footer className="bg-[#224cc4] text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <p className="text-blue-100 mb-4">
            © {new Date().getFullYear()} Suncore International General Trading FZE. All rights reserved.
          </p>
          <div className="flex justify-center gap-6 text-sm">
            <a href="/privacy" className="text-blue-200 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" className="text-blue-200 hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
